import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { Form, Formik } from "formik";
import { useSelector } from "react-redux";
import FormikActions from "../../../../../../../../commons/formik/FormikActions";
import FormikTextField from "../../../../../../../../commons/formik/FormikTextField";
import CircularLoading from "../../../../../../../../commons/loading/CircularLoading";
import { StyledResolucion } from "../../../../../../../../styled/Prevencion";
import { ValidateComprador, ValidateProveedor } from "../../../formValidations";

const ProveedoresForm = ({
    values,
    open,
    handleClose,
    handleSubmit,
    id,
    loading,
    esComprador
}) => {
    const proveedores = useSelector((state) => esComprador ? state.resolucion.abmSustancia.compradores : state.resolucion.abmSustancia.proveedores);

    return (
        <Dialog open={open} >
            <DialogTitle>{esComprador ? "Comprador" : "Proveedor"}</DialogTitle>

            {loading ?
                <CircularLoading />
                : (

                    <Formik
                        initialValues={values}
                        onSubmit={(values) => handleSubmit(values)}
                        validationSchema={
                            esComprador ?
                                ValidateComprador(proveedores, id)
                                : ValidateProveedor(proveedores, id)
                        }
                    >
                        {({ values }) => (
                            <Form>
                                <DialogContent>
                                    <Grid container>
                                        <StyledResolucion.DialogGridItem item xs={12} >
                                            <FormikTextField
                                                name="razonSocial"
                                                label="Razon Social*"
                                                fullWidth
                                            />
                                        </StyledResolucion.DialogGridItem>

                                        <StyledResolucion.DialogGridItem item xs={8} >
                                            <FormikTextField
                                                name="cuit"
                                                label="CUIT*"
                                                fullWidth
                                            />
                                        </StyledResolucion.DialogGridItem>
                                    </Grid>
                                </DialogContent>

                                <DialogActions>
                                    <FormikActions handleCancel={handleClose} />
                                </DialogActions>
                            </Form>
                        )}
                    </Formik>
                )
            }

        </Dialog>
    )
}

export default ProveedoresForm;